export { default } from "./ClaimProcessingDetails.gql";
